import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

const selectVariableState = (state: RootState) => state.variableManager;

export const getAllVariables = createSelector(
	[selectVariableState],
	(variableState) => variableState.variables,
);

export const getVariableByName = (name: string) =>
	createSelector([getAllVariables], (variables) => variables[name] || null);

export const getVariableNames = createSelector([getAllVariables], (variables) =>
	Object.keys(variables),
);
